// src/pages/SadasyaKaryakarini.js
import React from "react";

const SadasyaKaryakarini = () => {
  const currentDate = new Date().toLocaleDateString("en-IN");
  const currentTime = new Date().toLocaleTimeString("en-IN");

  return (
    <div style={styles.container}>
      {/* ===== Header ===== */}
      <header style={styles.header}>
        <div style={styles.logo}>
          <div style={styles.logoCircle}>GP</div>
        </div>
        <div style={styles.title}>
          <h1 style={styles.mainTitle}>गट ग्रामपंचायत खापरी-उबगी</h1>
          <p style={styles.subTitle}>पंचायत समिती कळमेश्वर | जिल्हा परिषद नागपूर</p>
          <p style={styles.timestamp}>अद्ययावत: {currentDate} | वेळ: {currentTime}</p>
        </div>
      </header>

      {/* ===== मुख्य शीर्षक ===== */}
      <section style={styles.heroSection}>
        <h2 style={styles.heroTitle}>
          ग्रामपंचायत सदस्य: वॉर्डाचा विकास, गावाचा संकल्प
        </h2>
        <p style={styles.heroSubtitle}>
          लोकशाहीचे खरे शिल्पकार
        </p>
      </section>

      {/* ===== परिचय ===== */}
      <section style={styles.introSection}>
        <p style={styles.introText}>
          ग्रामपंचायत सदस्य म्हणून, <strong>आम्ही गट ग्रामपंचायत खापरी-उबगी नागरिकांप्रती प्रत्यक्ष आणि महत्त्वपूर्ण जबाबदारी घेतो</strong>. आम्ही फक्त सदस्य नाही, तर <em>विकासाचे दूत (Ambassadors of Development)</em> आहोत. गावाच्या गरजा जाणून घेण्यापासून ते निर्णयांच्या अंमलबजावणीपर्यंत, आमची भूमिका अत्यंत महत्त्वाची आहे.
        </p>
      </section>

      {/* ===== वॉर्ड-निहाय जबाबदारी ===== */}
      <section style={styles.responsibilitySection}>
        <h3 style={styles.sectionTitle}>सदस्यांची वॉर्ड-निहाय जबाबदारी</h3>
        <p style={styles.responsibilityIntro}>
          प्रत्येक सदस्य आपल्या वॉर्डातील नागरिकांसाठी खालील <strong>पाच प्रमुख कामांवर</strong> लक्ष केंद्रित करतो:
        </p>

        <div style={styles.responsibilityGrid}>
          <div style={styles.responsibilityCard}>
            <span style={styles.icon}>Checklist</span>
            <h4>समस्यांचे संकलन</h4>
            <p>वॉर्डातील लहान-मोठ्या समस्या (उदा. नालेसफाई, पाणी गळती, पथदिव्यांची दुरुस्ती) दररोज नोंदवून त्या प्रशासनाकडे वेळेत पोहोचवणे.</p>
          </div>

          <div style={styles.responsibilityCard}>
            <span style={styles.icon}>People</span>
            <h4>लाभार्थ्यांची निवड</h4>
            <p>शासकीय योजनांसाठी (उदा. घरकुल, इंदिरा गांधी वृद्धापकाळ योजना) योग्य आणि गरजू लाभार्थ्यांची निवड ग्रामसभेच्या मान्यतेने करणे.</p>
          </div>

          <div style={styles.responsibilityCard}>
            <span style={styles.icon}>Guide</span>
            <h4>नागरिकांना मार्गदर्शन</h4>
            <p>ग्रामपंचायतीच्या कामकाजाबद्दल, टॅक्स (कर) भरण्याबद्दल किंवा कोणत्याही शासकीय कागदपत्रांबद्दल वॉर्डातील नागरिकांना योग्य मार्गदर्शन करणे.</p>
          </div>

          <div style={styles.responsibilityCard}>
            <span style={styles.icon}>Handshake</span>
            <h4>उत्तम समन्वय</h4>
            <p>सरपंच, उपसरपंच आणि ग्रामसेवक यांच्यासोबत सतत समन्वय ठेवून विकासाच्या कामांमध्ये गती आणणे.</p>
          </div>

          <div style={styles.responsibilityCard}>
            <span style={styles.icon}>Megaphone</span>
            <h4>जागृती आणि सहभाग</h4>
            <p>शासनाच्या नवीन योजना (उदा. डिजिटल सेवा, आरोग्य अभियान) यांची माहिती वॉर्डातील प्रत्येक कुटुंबापर्यंत पोहोचवून त्यांना सक्रिय सहभाग घेण्यासाठी प्रेरित करणे.</p>
          </div>
        </div>
      </section>

      {/* ===== सामूहिक वचनबद्धता ===== */}
      <section style={styles.commitmentSection}>
        <h3 style={styles.sectionTitle}>सामूहिक वचनबद्धता</h3>
        <blockquote style={styles.quote}>
          "आम्ही, गट ग्रामपंचायत खापरी-उबगी सर्व सदस्य, पक्षीय मतभेद बाजूला ठेवून, केवळ गाव हितासाठी एकजुटीने काम करण्यास वचनबद्ध आहोत. तुमचा विश्वास आणि सहकार्य आम्हाला अधिक चांगले काम करण्याची प्रेरणा देईल."
        </blockquote>
      </section>

      {/* ===== फूटर ===== */}
      <footer style={styles.footer}>
        <p>© 2025 गट ग्रामपंचायत खापरी-उबगी | सर्व हक्क राखीव</p>
        <p>वेबसाइट: <a href="https://gpkhapari-ubagi.in" style={styles.link}>gpkhapari.in</a></p>
      </footer>
    </div>
  );
};

// ====== Internal CSS (Simple & Clean) ======
const styles = {
  container: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    maxWidth: "900px",
    margin: "20px auto",
    padding: "20px",
    background: "#f9f9fb",
    border: "2px solid #5e35b1",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    color: "#333",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "3px solid #5e35b1",
    paddingBottom: "15px",
    marginBottom: "25px",
  },
  logo: {
    marginRight: "15px",
  },
  logoCircle: {
    width: "70px",
    height: "70px",
    background: "#5e35b1",
    color: "white",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    fontWeight: "bold",
  },
  title: {
    flex: 1,
  },
  mainTitle: {
    margin: 0,
    fontSize: "26px",
    color: "#4527a0",
    fontWeight: "bold",
  },
  subTitle: {
    margin: "5px 0",
    fontSize: "16px",
    color: "#555",
  },
  timestamp: {
    margin: "5px 0",
    fontSize: "14px",
    color: "#c62828",
    fontWeight: "bold",
  },

  // हीरो सेक्शन
  heroSection: {
    textAlign: "center",
    marginBottom: "30px",
    padding: "20px",
    background: "linear-gradient(135deg, #ede7f6, #d1c4e9)",
    borderRadius: "12px",
  },
  heroTitle: {
    margin: "0 0 10px 0",
    fontSize: "24px",
    color: "#4527a0",
    fontWeight: "bold",
  },
  heroSubtitle: {
    margin: 0,
    fontSize: "18px",
    color: "#6a1b9a",
    fontStyle: "italic",
  },

  // परिचय
  introSection: {
    marginBottom: "30px",
    background: "#ffffff",
    padding: "20px",
    borderRadius: "10px",
    borderLeft: "5px solid #7e57c2",
  },
  introText: {
    fontSize: "16px",
    lineHeight: "1.8",
    margin: 0,
  },

  // जबाबदाऱ्या
  responsibilitySection: {
    marginBottom: "30px",
  },
  sectionTitle: {
    color: "#4527a0",
    borderBottom: "2px solid #4527a0",
    paddingBottom: "8px",
    marginTop: 0,
    marginBottom: "20px",
    fontSize: "20px",
  },
  responsibilityIntro: {
    marginBottom: "20px",
    fontSize: "16px",
  },
  responsibilityGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "15px",
  },
  responsibilityCard: {
    background: "#f3e5f5",
    padding: "15px",
    borderRadius: "10px",
    border: "1px solid #ce93d8",
    textAlign: "center",
    transition: "transform 0.2s",
  },
  icon: {
    fontSize: "32px",
    display: "block",
    marginBottom: "10px",
  },

  // वचनबद्धता
  commitmentSection: {
    marginBottom: "30px",
    background: "linear-gradient(135deg, #e8eaf6, #c5cae9)",
    padding: "25px",
    borderRadius: "12px",
    textAlign: "center",
    border: "2px dashed #5c6bc0",
  },
  quote: {
    fontSize: "18px",
    lineHeight: "1.8",
    margin: 0,
    color: "#1a237e",
    fontStyle: "italic",
    fontWeight: "bold",
  },

  // फूटर
  footer: {
    textAlign: "center",
    paddingTop: "20px",
    borderTop: "1px solid #ddd",
    fontSize: "14px",
    color: "#666",
  },
  link: {
    color: "#4527a0",
    textDecoration: "none",
  },
};

export default SadasyaKaryakarini;